export const contains = (value?: string, searchBy?: string) => {
  if (value && searchBy) {
    const searchByValue = searchBy.replace(/ /g, "").toLowerCase();
    return value.replace(/ /g, "").toLowerCase().includes(searchByValue);
  }

  return false;
};
